import { PHONE_MASK } from '../../../../..';

export const DEFAULT_PLACEHOLDER = PHONE_MASK.replace(/\d/g, '0');
